import { Component, OnInit, Input, ViewChild, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { Entry } from 'contentful';
import { ThankYouPage } from '../../_models/thank-you-page.model';
import { CssInjectorService } from '../../_services/css-injector.service'; 


@Component({
  selector: 'app-thank-you-page-v1',
  standalone: false,
  templateUrl: './thank-you-page-v1.component.html',
  styleUrl: './thank-you-page-v1.component.css'
})
export class ThankYouPageV1Component implements OnInit {
  @Input() thankYouPageContent: Entry<ThankYouPage> | undefined;

  constructor(
    private cssInjectorService: CssInjectorService
   ) { }


  ngOnInit() {
    this.loadComponent(this.thankYouPageContent);
    
    var customStyle = this.thankYouPageContent?.fields?.customStyle as unknown as string;
    this.cssInjectorService.injectCSS('thank-you-page', customStyle);      


  }
  
  
  
  private loadComponent(config: Entry<ThankYouPage> | undefined) { 
  }







}
